import React from "react";
import PropTypes from 'prop-types';
import Modal from "react-bootstrap/Modal";
import RegisteredStep from "./RegisterStep/RegisteredStep";
import CreateOrUploadCVStep from "./RegisterStep/CreateOrUploadCVStep";
import {getStyle} from "../../services/Style";
import RegisterStepBreadCrumbs from "./RegisterStep/RegisterStepBreadCrumbs";
import RegisterStep from "./RegisterStep/RegisterStep";
import renderLoader from "../base/Loader";
import PositionExpiredInvalid from "../position/PositionExpiredInvalid";
import {sprintf} from "sprintf-js";
import {uploadFileToMongo} from "../../services/PostService";

export default class Register extends React.PureComponent
{
    static propTypes = {
        positionId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        customerName: PropTypes.string.isRequired,
        language: PropTypes.string.isRequired,
        customerData: PropTypes.objectOf(Promise).isRequired,
        positionData: PropTypes.objectOf(Promise),
        setBannerData: PropTypes.func.isRequired
    };

    static defaultProps = {
        positionId: null,
        positionData: null
    };

    constructor(props) {
        super(props);
        this.state = {
            step: sessionStorage.getItem('userId-'+this.props.customerName) ? 2 : 1,
            loading: true,
            modalShow: false,
            modalTitle: null,
            modalText: '',
            firstName: null,
            lastName: null,
            email: null,
            sex: null,
            phone: null,
            errorReason: null,
            prescreeningOnly: false
        };
        this.loadData();
    }

    renderErrorScreen = (reason) => {
        this.setState({errorReason: reason? reason: 'undefined'})
        this.forceUpdate()
    }

    loadData = () => {
        Promise.all([this.props.positionData, this.props.customerData]).then(([positionData, customerData]) => {
			let requireCv = (!positionData || !positionData.result || positionData.result['portal_data']['requireCv'] === undefined || positionData.result['portal_data']['requireCv'] === 'default') ?
				customerData.result['requiredCV'] : positionData.result['portal_data']['requireCv']
			let prescreeningOnly = false
            let step = 1
            if (sessionStorage.getItem('userId-'+this.props.customerName) !== null) {
                if (!requireCv || sessionStorage.getItem('cv-uploaded')) {
                    step = 2
                    prescreeningOnly = true
                }
            }
			if (customerData.result.gateSettings['skipCv'] === '1') {
				step = 2
			}

			this.setState({
                loading: false,
                positionData: positionData,
                requireCv: Boolean(requireCv),
				skipCv: Boolean(customerData.result.gateSettings['skipCv'] === '1'),
                customerData: customerData,
                step: step,
                prescreeningOnly: prescreeningOnly
            });
        });
    };

    nextStep = () => {
        this.setState({step: this.state['step'] + 1});
    };

    setCandidateData = (firstName, lastName, sex, email, phone) => {
        this.setState({firstName: firstName, lastName: lastName, sex: sex,  email: email, phone: phone});
    };

	maxSizeMb = 10;
	maxSize = this.maxSizeMb * 1024 * 1024;
	showModal = (modalTitle, modalText) => {
		this.setState({showModal: true, modalTitle: modalTitle, modalText: modalText});
	};

	uploadToMongo = (file) => {
		if (!file) {
			return;
		}

		const allowedExtensions =
			/(\.pdf|\.docx|\.doc|\.odt|\.rtf)$/i;

		if (!allowedExtensions.exec(file.name)){
			this.showModal(window.Translator.getSlug('Error', this.props.language), sprintf(window.Translator.getSlug('InvalidFileFormat', this.props.language)));
			// reset file input
			if (this.fileInputRef.current) {
				this.fileInputRef.current.value = null;
			}
			return;
		}

		if (file.size > this.maxSize) {
			this.showModal(window.Translator.getSlug('Error', this.props.language), sprintf(window.Translator.getSlug('MaxFileSize%sMbExceeded', this.props.language), this.maxSizeMb));
			// reset file input
			if (this.fileInputRef.current) {
				this.fileInputRef.current.value = null;
			}
			return;
		}

		this.setState({loading: true});
		uploadFileToMongo(file, this.props.customerName, this.props.language, '')
			.then(response => response.json())
			.then(json => {
				if (sessionStorage.getItem('userId-' + this.props.customerName)) {
					this.setCandidateData(null, null, null, null, null);
					sessionStorage.clear();
				}
				json.mongoId !== undefined && sessionStorage.setItem('cv-file-mongoid', json.mongoId);
				sessionStorage.setItem('cv-file-name', file.name);
				sessionStorage.setItem('cv-file-size', file.size);
				sessionStorage.setItem('cv-uploaded', json.mongoId);
				if (json.hasOwnProperty('dataToLocalStorage') && json.dataToLocalStorage && Object.values(json.dataToLocalStorage).length > 0) {
					this.setCandidateData(
						json.dataToLocalStorage['firstName'],
						json.dataToLocalStorage['lastName'],
						parseInt(json.dataToLocalStorage['sex']),
						json.dataToLocalStorage['email'],
						json.dataToLocalStorage['phone']
					);
				}

				if (!this.state['skipCv']) {
					this.nextStep();
				}

				if (!json.success) {
					this.showModal(window.Translator.getSlug('Error', this.props.language), json.hasOwnProperty('reason') ? json.reason : '');
				}
				this.setState({loading: false});
			})
			.catch(error => {
				this.showModal(window.Translator.getSlug('Error', this.props.language), error.toString());
				this.setState({loading: false});
			});
	};



    closeModal = () => {
        this.setState({showModal: false});
    };

    renderStep = () => {
	    // eslint-disable-next-line default-case
      switch (this.state['step']) {
          case 1 :
              return (
                  <>
                      <RegisterStepBreadCrumbs
                          customerName={this.props.customerName}
                          language={this.props.language}
                          positionName={this.props.positionId ? this.state['positionData'].result.data.name : null}
                          positionId={this.props.positionId}
                          positionListLink={`/${this.props.language}/gate/${this.props.customerName}/positions`}
                          positionLink={this.props.positionId ? `/${this.props.language}/gate/${this.props.customerName}/position/${this.props.positionId}` : null}
                      />
                      <div className={"details-information section-padding-30"}>
                          <div className={'row'}>
                              <div className={'col-12 padding-bottom-30'}>
                                  <h5>{window.Translator.getSlug('StartWithAttachingOfYourCv', this.props.language)}</h5>
                                  {!this.state['requireCv'] && <p>{window.Translator.getSlug('IfYouDontHaveCvYouCanCreateOne', this.props.language)}</p>}
                              </div>
                              <CreateOrUploadCVStep
                                  customerName={this.props.customerName}
                                  language={this.props.language}
                                  positionId={this.props.positionId}
                                  nextStep={this.nextStep}
                                  changeCandidateData={this.setCandidateData}
                                  showModal={this.showModal}
                                  requireCv={this.state['requireCv']}
                                  setBannerData={this.props.setBannerData}
								  uploadToMongo={this.uploadToMongo}
                              />
                          </div>
                      </div>
                  </>
              );
          case 2:
              return (
                  <>
                      <RegisterStepBreadCrumbs
                          customerName={this.props.customerName}
                          language={this.props.language}
                          positionName={this.props.positionId ? this.state['positionData'].result.data.name : null}
                          positionId={this.props.positionId}
                          positionListLink={`/${this.props.language}/gate/${this.props.customerName}/positions`}
                          positionLink={this.props.positionId ? `/${this.props.language}/gate/${this.props.customerName}/position/${this.props.positionId}` : null}
                      />
                      <RegisterStep
                          language={this.props.language}
                          positionId={this.props.positionId}
                          nextStep={this.nextStep}
                          setBannerData={this.props.setBannerData}
                          firstName={this.state['firstName']}
                          lastName={this.state['lastName']}
                          email={this.state['email']}
                          sex={this.state['sex']}
                          phone={this.state['phone']}
                          showModal={this.showModal}
                          customerData={this.props.customerData}
                          customerName={this.props.customerName}
                          renderError={this.renderErrorScreen}
                          formUrl={this.state['positionData'] ? this.state['positionData'].result.form : null}
						  requireCv={this.state['requireCv']}
                          prescreeningOnly={this.state['prescreeningOnly']}
						  uploadToMongo={this.uploadToMongo}
                      />

                  </>
              );

          case 3:
              return (
                  <RegisteredStep
                      language={this.props.language}
                      customerName={this.props.customerName}
					  positionId={this.props.positionId}
					  uploadToMongo={this.uploadToMongo}
                  />
              )
      }
    };


    render() {
        let {showModal, modalText, modalTitle} = this.state;
        if (this.state['loading']) {
            return renderLoader('d-block text-center display-3');
        }
        if ((this.props.positionId && (!this.state['positionData'] || !this.state['positionData'].success)) || this.state['errorReason'] ) {
            let reason = this.state['positionData'] && this.state['positionData']['reason'] ? this.state['positionData']['reason'] : null

            if (this.state['errorReason']) {
                reason = this.state['errorReason']
            }

            return (
                <PositionExpiredInvalid
                    customerName={this.props.customerName}
                    positionId={this.props.positionId}
                    language={this.props.language}
                    reason={reason}
                />
            );
        }
        return (
            <div className="section-padding-bottom alice-bg flexHeight">
                <div className="alice-bg padding-top-30 section-padding-bottom flexHeight2" style={getStyle(this.props.positionId, 'backgroundColor', this.props.customerName)}>
                    <div className="container">
                        <div className="job-listing-details job-detail-position">
                            <Modal show={showModal} onHide={this.closeModal} animation={false} dialogClassName={'smallDialog'}>
                                <Modal.Header>
                                    <Modal.Title>{modalTitle}</Modal.Title>
                                </Modal.Header>
                                <Modal.Body>{modalText}</Modal.Body>
                                <Modal.Footer>
                                    <button onClick={this.closeModal} className={'btn btn-default'}>
                                        {window.Translator.getSlug('Close', this.props.language)}
                                    </button>
                                </Modal.Footer>
                            </Modal>
                            {this.renderStep()}
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
